




import Vue from 'vue';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import NewContainer from '@/containers/cv-section-link/new.vue';

import * as CvSectionLinkStoreNew from '@/store/modules/cvSectionLinkNew';

export default Vue.extend({
  components: {
    NewContainer,
  },
  mixins: [PageLeftHook],
  data() {
    return {
      storeList: [CvSectionLinkStoreNew],
    };
  },
});
